import { useTranslation } from 'react-i18next';
import { TableCell } from '@mui/material';
import { getUserRole } from '@shared/static/roles';

export function MemberName({ row }) {
  const { t } = useTranslation();

  return (
    <>
      <p className="fw-500">{row.name}</p>
      <p className="secondary-text">{t(getUserRole(row.group_role))}</p>
    </>
  );
}

export default function MemberCell({ row }) {
  return (
    <TableCell>
      <MemberName row={row} />
    </TableCell>
  );
}
